import { Button, Form, Input, Modal, Select, Space, Drawer } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { connect } from "react-redux";
import { AppState } from "src/store";
import style from './Tables.module.scss'
import { useEffect, useState } from "react";
import {getAllTagTable,getTagById,postRegisterTag,putUpdateTag} from 'src/store/tag/thunks';
import { SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined } from '@ant-design/icons';
import { SizeType } from "antd/es/config-provider/SizeContext";
import validateMessages from "src/globals/Inputs/validateMessages";
import TextArea from "antd/es/input/TextArea";
import form from "antd/es/form";
import { NamePath } from "antd/es/form/interface";
import {Tag} from 'src/store/tag/types';
import { validate1, validate150, validateNumber } from "src/globals/Inputs/validateInput";
import { getUserByToken } from "src/store/user/thunks";


interface TableProps {
    getAllTagTable?: any;
    getTagById? : any;
    postRegisterTag? : any;
    putUpdateTag? : any;
    getUserByToken?:any;
}

/*id:string
    name:string,
    type:string,    
    description:string,
    created_at:string*/

interface DataType {
    key: string;
    id: string;
    name: string;
    description: string;
    created_at: string;
    updated_at: string;
}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';
const TTag: React.FC<TableProps> = (props: TableProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [typeModal, setTypeModal] = useState(true);
    const [idTag, setIdTag] = useState('');
    const [formValidate] = Form.useForm();
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [isRol, setIsRol] = useState('');
    const { Option } = Select;
    //LLamar al EndPoint tanto en el Iterface como en el Map, 
    const init = async () => {
        const rol = await props.getUserByToken();
        setIsRol(rol);
        const responseDataTag = await props.getAllTagTable();
        setDataTable(responseDataTag);
    }
    useEffect(() => {
        init();
    }, []);

    //Crear una tabla.
    const [dataTable, setDataTable] = useState([]);

    const columns: ColumnsType<DataType> = [
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Nombre',
            width: 25,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            //...getColumnSearchProps('name', 'nombre'),
        },
        {
            title: 'Descripción',
            width: 20,
            dataIndex: 'description',
            key: 'description',
            //fixed: 'left',
            //...getColumnSearchProps('ruc', 'ruc'),
        },
        {
            title: 'Fecha de creación',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 15,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },
        {
            title: 'Fecha de modificación',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            width: 15,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.updated_at);
                const dateB = new Date(b.updated_at);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },     

    ];

    if (isRol === "ec438afc-63f2-4acf-b1d4-e51df3043190") {
        columns.push({
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 3,
            render: (record: DataType) => (
                <Space size="middle">
                    <Button
                        type="text"
                        className={style["update-button"]}
                        onClick={() => handleTypeOpenModelUpdate(record.id)}
                        icon={<EditOutlined />}
                    />
                </Space>
            ),
        });
    }
    
    const handleCancel = () => {
        formValidate.resetFields();
        setIsModalOpen(false)
    };
    const handleTypeOpenModel = () => {
        setIsModalOpen(true)
        setTypeModal(true)
    };
    const handleTypeOpenModelUpdate = async (value: String) => {
        setIsModalOpen(true)
        setTypeModal(false)
        const responseData: Tag = await props.getTagById(value);
        setIdTag(responseData.id)
        formValidate.setFieldsValue({
            name: responseData.name, description: responseData.description
        });
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const onFinish = async (values: any) => {
        if (!typeModal) {
            const Source = {
                id: idTag,                
                name: values.name,
                description: values.description,
            };
            await props.putUpdateTag(Source);
        } else {
            const Source = {
                name: values.name,
                description: values.description,
            };
            await props.postRegisterTag(Source);
        }
        handleCancel();
        const responseData = await props.getAllTagTable();
        setDataTable(responseData);
        formValidate.resetFields();
    };

    return (
        <>
            { isRol == "ec438afc-63f2-4acf-b1d4-e51df3043190" &&<Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={handleTypeOpenModel}
            >
                Crear Tag
            </Button>}
            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1500 }} />
            <Drawer title= {typeModal ? "Crear Tag" : "Actualizar Tag"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item  label="Nombre" name="name" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input   placeholder="Ingresar nombre" />
                    </Form.Item>
                    <Form.Item  label="Ingresar descripción" name="description" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input  placeholder="Ingresar descripción" />
                    </Form.Item>
                    
                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Ingresar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>


    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getAllTagTable,getTagById,postRegisterTag,putUpdateTag, getUserByToken
})(TTag);